import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { IHttpBasicResponse } from '@boxx/core';

export interface IContactRepository {
  getContacts(): Observable<IHttpBasicResponse<IContactApiProps[]>>;
  getContactInteractions(
    contactId: number
  ): Observable<IHttpBasicResponse<any[]>>;
  createContact(
    form: IContactForm
  ): Observable<IHttpBasicResponse<IContactApiProps>>;
  delete(contactId: number): Observable<IHttpBasicResponse<string>>; // success | error
  update(form: IContactForm): Observable<IHttpBasicResponse<IContactApiProps>>;
  import(
    payload: IContactApiProps[]
  ): Observable<IHttpBasicResponse<IImportContactsResponse>>;
  createInteraction(
    contactId: number,
    config: IGenericInteractionProps
  ): Observable<IHttpBasicResponse<IContactInteractionsApiProps>>;
}

export const CONTACTS_REPOSITORY = new InjectionToken<IContactRepository>(
  'contactsRepository'
);

// eslint-disable-next-line @typescript-eslint/naming-convention
export type CONTACT_FILTER_TYPE =
  | 'ALL'
  | 'NOT_SPECIFIED'
  | 'PROSPECT'
  | 'CLIENT';

// eslint-disable-next-line @typescript-eslint/naming-convention
export type CONTACT_TYPE = 'NOT_SPECIFIED' | 'PROSPECT' | 'CLIENT';

// eslint-disable-next-line @typescript-eslint/naming-convention
export type CONTACT_ORIGIN =
  | 'MANUAL'
  | 'MOBILE_APP'
  | 'WEB'
  | 'WEB_APP'
  | 'UNKNOWN';
// eslint-disable-next-line @typescript-eslint/naming-convention
export type INTERACTION_TYPE =
  | 'CREATE'
  | 'UPDATE_TYPE'
  | 'CONTACT_CALL'
  | 'CONTACT_SCHEDULED'
  | 'CONTACT_WHATSAPP'
  | 'CONTACT_EMAIL'
  | 'CONTACT_SALE'
  | 'CONTACT_PAYMENT';

export interface IImportContactsResponse {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  contacts_exported: Array<IContactApiProps>;
}

export interface IContactForm {
  // Required
  name: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  last_name: string;
  type: CONTACT_TYPE;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  country_code: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  phone_code: string;

  // Optionals
  id?: number;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  contact_id?: number;
  phone?: string;
  email?: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  street_address?: string;
  city?: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  state_iso?: string;
}

export interface IImportContactsForm {
  addresses: any[];
  // { "id": string, "pref": boolean, "type": string, "formatted": string, "streetAddress": string },
  birthday: string;
  displayName: string;
  emails: any[];
  // { "id": string, "pref": boolean, "value": string, "type": string },
  name: {
    familyName: string;
    givenName: string;
    middleName: string;
    formatted: string;
  };
  nickname: string;
  phoneNumbers: any[];
  // { "id": string, "pref": boolean, "value": string, "type": string },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  client_type: number;
}

// GET | CREATE | UPDATE | IMPORT
export interface IContactApiProps {
  id: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  client_id?: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  country_code?: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  phone_code?: string;
  name: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  last_name: string;
  type?: CONTACT_TYPE;
  origin?: CONTACT_ORIGIN;
  email: string;
  phone: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  street_address?: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  state_iso?: string;
  city?: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  created_at?: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  updated_at?: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  full_name: string;
}

export interface IContactInteractionsApiProps {
  id: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  contact_id: string;
  entity: 'contacts';
  // eslint-disable-next-line @typescript-eslint/naming-convention
  entity_id: number | string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  action_type: INTERACTION_TYPE;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  created_at: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  display_text: string;
}

export interface IGenericInteractionProps {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  action_type: string;
  entity: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  entity_id: number | string;
}
